<template>
  <div class="product">
    <div slot="no-body" class="image-cont">
      <img
        v-if="productItem.thumbnail && productItem.thumbnail.url"
        :src="productItem.thumbnail.url"
        :alt="productItem.title"
        class="product-image responsive rounded-lg"
        :style="{ opacity: !productItem.available ? 0.2 : 1 }"
      />
      <img
        v-else
        src="../../../assets/images/placeholder.jpg"
        class="product-image responsive rounded-lg"
      />
      <div v-if="!product.available">
        <img
          src="../../../assets/images/unavailable.png"
          alt="unavailable"
          class="unavailable-image"
        />
      </div>
      <div
        v-if="productItem.featured || productItem.discount > 0"
        class="specials"
      >
        <span v-if="productItem.featured" class="special-item featured">{{
          "ویژه"
        }}</span>
        <div v-else />
        <span v-show="productItem.discount > 0" class="special-item discount"
          >{{ productItem.discount }}%</span
        >
      </div>
    </div>
    <div class="footer-cont">
      <div class="body">
        <h5 class="title">
          {{ productItem.title }}
        </h5>
      </div>
      <div class="buttons">
        <vs-button
          @click="showEditPopup = true"
          class="mr-1"
          color="primary"
          type="filled"
          size="small"
          icon-pack="feather"
          icon="icon-edit"
        />
        <vs-button
          @click="remove()"
          class="ml-1"
          color="danger"
          type="filled"
          size="small"
          icon-pack="feather"
          icon="icon-trash"
        />
      </div>
    </div>
    <vs-popup
      v-if="showEditPopup"
      title="ویرایش محصول"
      :active.sync="showEditPopup"
    >
      <product-input
        v-model="productItem"
        :categories="categories"
        :activeCategory="activeCategory"
        :activeSubCategory="activeSubCategory"
        @productUpdated="productUpdated"
        @close="showEditPopup = false"
      >
      </product-input>
    </vs-popup>
  </div>
</template>

<script>
import ProductInput from "../ProductInput.vue";

export default {
  name: "Product",
  components: {
    ProductInput,
  },
  data() {
    return {
      productItem: {
        ...this.product,
        featured: +this.product.featured,
      },
      showEditPopup: false,
    };
  },
  watch: {
    product(newProduct) {
      this.productItem = newProduct;
    },
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    categories: {
      type: Array,
      required: true,
    },
    activeCategory: {
      type: Object,
      required: true,
    },
    activeSubCategory: {
      type: Object,
      required: false,
    },
  },
  methods: {
    productUpdated(resource, category, subCategory) {
      if (
        category.id === this.activeCategory?.id &&
        subCategory?.id === this.activeSubCategory?.id
      ) {
        this.productItem = {
          ...resource,
          featured: +resource.featured,
        };
      } else {
        this.$emit("productCategoryChanged", resource, category, {
          current: this.activeSubCategory,
          target: subCategory,
        });
      }
    },
    remove() {
      this.$vs.dialog({
        type: "confirm",
        color: "warning",
        title: `حذف محصول`,
        text: `از حذف محصول "${this.product.title}" اطمینان دارید؟`,
        acceptText: "بلی",
        cancelText: "خیر",
        accept: () => {
          this.$emit("delete");
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.product {
  overflow: hidden;
  margin: 4px;
  border-radius: 5px;
  box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.1);

  .title {
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    /* number of lines to show */
    line-clamp: 1;
    -webkit-box-orient: vertical;

    @media (max-width: 440px) {
      font-size: 12px;
    }
  }

  .footer-cont {
    padding: 10px;

    .body {
      height: 50%;
      margin-bottom: 10px;
    }

    .buttons {
      display: flex;
      justify-content: flex-end;
      height: 50%;
    }
  }

  .image-cont {
    background-color: #232323;
    position: relative;
    display: flex;

    .product-image {
      height: 100px;
      object-fit: cover;
      object-position: center;
      border-bottom-left-radius: 0 !important;
      border-bottom-right-radius: 0 !important;
    }

    .unavailable-image {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      width: 60%;
    }

    .specials {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      background-image: linear-gradient(to bottom, #232323, transparent);

      .special-item {
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #f44336;
        padding: 0 5px;
        border-radius: 5px;
        box-shadow: 0 7px 24px 0 rgba(244, 67, 54, 0.4);
        color: white;
        font-size: 0.85rem;
        margin: 5px;
        height: 22px;
      }

      .featured {
        font-weight: 100;
      }

      .discount {
        padding-top: 4px;
      }
    }
  }
}
</style>
